import React, {useState, useEffect} from 'react';
import { Nav, Navbar, NavLink, NavItem, Button } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { Cookies } from 'react-cookie';
import { useTranslation } from 'react-i18next'
import Customize from './Customize'

const constants = require('./constants');

const cookies = new Cookies();
// eslint-disable-next-line
export default props => {
  const [count, setCount] = useState(0);
  const [allowRequestState, setAllowRequest] = useState(false);
  const { t } = useTranslation();

  const parentEventSend = props.parentEventCb;

  useEffect(() => {

    const checkFetchRespSession = (resp)=> {
      if (!resp.ok) {
        if(resp.status === 401) {
          parentEventSend("SESSION_EXPIRED");
        }
        throw Error(resp.statusText);
      }
      return resp;
    }

    console.log("allowRequest state", cookies.get('allowRequest'));

    if(cookies.get('allowRequest',{ doNotParse: true }) === 'true') {
      setAllowRequest(true);
    }

    fetch(constants.SERVER_URL+"/api/pendingcount",{method:'get'})
    .then(resp => checkFetchRespSession(resp))     
    .then(resp =>resp.json())
    .then(data => setCount(data.count))
    .catch(error => {
      console.log("Fetching signeddocs error:", error);
      setCount(0);
    });
  }, [props.menuRefresh, parentEventSend]);

  const logout = () => {
    console.log("logout sessiontoken", cookies.get('sessionToken'));
      if(cookies.get('sessionToken') !== undefined) {
        // logged in -> possible to logout
        return (
          <LinkContainer to={constants.SERVER_CONTEXT_PATH+'/logout'}>
            <NavLink>
              <svg width="24" height="24" fill="currentColor" className="nav-link-icon" viewBox="0 0 16 16">
                <path fillRule="evenodd" d="M5.578 4.437a5 5 0 1 0 4.922.044l.5-.866a6 6 0 1 1-5.908-.053l.486.875z"/>
                <path fillRule="evenodd" d="M7.5 8V1h1v7h-1z"/>
              </svg>
            {t("Logout")}
            </NavLink>
          </LinkContainer>
        );
      } else {
        return null;
       /* return ( // logged out -> possible to login
          <LinkContainer to={'/login'}>
            <NavLink>
                <Glyphicon glyph='log-in' /> Login
            </NavLink>
          </LinkContainer>
        );*/
      }
    }

const request = () => {
    if(allowRequestState) {
      return (
      <LinkContainer to={constants.SERVER_CONTEXT_PATH+'/request'}>
        <NavLink>
          <svg width="24" height="24" fill="currentColor" className="nav-link-icon" viewBox="0 0 16 16">
            <path fillRule="evenodd" d="M11.646 11.354a.5.5 0 0 1 0-.708L14.293 8l-2.647-2.646a.5.5 0 0 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0z"/>
            <path fillRule="evenodd" d="M4.5 8a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5z"/>
            <path fillRule="evenodd" d="M2 13.5A1.5 1.5 0 0 1 .5 12V4A1.5 1.5 0 0 1 2 2.5h7A1.5 1.5 0 0 1 10.5 4v1.5a.5.5 0 0 1-1 0V4a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-1.5a.5.5 0 0 1 1 0V12A1.5 1.5 0 0 1 9 13.5H2z"/>
          </svg>
          {t("Request Signature")}
        </NavLink>
      </LinkContainer>)
    } else {
      return null;
    }
}

const doRender = () => {
    if(cookies.get('sessionToken') !== undefined) {
      // logged in -> show menu
      return (
        <Navbar collapseOnSelect expand="sm" fixed="top" className="flex-sm-column navbar-custom">
            <Navbar.Brand >
              <Navbar.Toggle aria-controls="responsive-navbar-nav"/>
              {' '}<Customize.NavMenuLogo />
              </Navbar.Brand>
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="flex-sm-column navbar-common" variant="pills">
              <LinkContainer to={constants.SERVER_CONTEXT_PATH+'/'} exact>
                  <NavLink id={"nav-item-home"}>
                  <svg width="24" height="24" fill="currentColor" className="nav-link-icon" viewBox="0 0 16 16">
                    <path fillRule="evenodd" d="M7.646 1.146a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 .146.354v7a.5.5 0 0 1-.5.5H9.5a.5.5 0 0 1-.5-.5v-4H7v4a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .146-.354l6-6zM2.5 7.707V14H6v-4a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v4h3.5V7.707L8 2.207l-5.5 5.5z"/>
                    <path fillRule="evenodd" d="M13 2.5V6l-2-2V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5z"/>
                  </svg>
                  {t("Home")}
                  </NavLink>
              </LinkContainer>
      
              <LinkContainer to={constants.SERVER_CONTEXT_PATH+'/pending'}>
                  <NavLink id={"nav-item-pending"}>
                  <svg width="24" height="24" fill="currentColor" className="nav-link-icon" viewBox="0 0 16 16">
                    <path fillRule="evenodd" d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456l-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                    <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
                  </svg>
                  {t("Signature requests", {count})}
                  </NavLink>
              </LinkContainer>
      
              {request()}
      
              <LinkContainer to={constants.SERVER_CONTEXT_PATH+'/signed'}>
                  <NavLink>
                  <svg width="24" height="24" fill="currentColor" className="nav-link-icon" viewBox="0 0 16 16">
                    <path fillRule="evenodd" d="M15.354 2.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L8 9.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                    <path fillRule="evenodd" d="M1.5 13A1.5 1.5 0 0 0 3 14.5h10a1.5 1.5 0 0 0 1.5-1.5V8a.5.5 0 0 0-1 0v5a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V3a.5.5 0 0 1 .5-.5h8a.5.5 0 0 0 0-1H3A1.5 1.5 0 0 0 1.5 3v10z"/>
                  </svg>
                  {t("Signed Documents")}
                  </NavLink>
              </LinkContainer>
              <LinkContainer to={constants.SERVER_CONTEXT_PATH+'/profile'}>
                  <NavLink>
                  <svg width="24" height="24" fill="currentColor" className="nav-link-icon" viewBox="0 0 16 16">
                    <path fillRule="evenodd" d="M13 14s1 0 1-1-1-4-6-4-6 3-6 4 1 1 1 1h10zm-9.995-.944v-.002.002zM3.022 13h9.956a.274.274 0 0 0 .014-.002l.008-.002c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664a1.05 1.05 0 0 0 .022.004zm9.974.056v-.002.002zM8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/>
                  </svg>
                  {t("Profile Settings")}
                  </NavLink>
                </LinkContainer>
                <div className="bottom">
                  {logout()}
                  <NavItem className="languageChoice">
                    <Button variant="primary" size="sm" onClick={() => props.updateLanguageCb("en")}>EN</Button>
                    <Button variant="primary" size="sm" onClick={() => props.updateLanguageCb("fi")}>FI</Button>
                    <Button variant="primary" size="sm" onClick={() => props.updateLanguageCb("se")}>SE</Button>
                  </NavItem>
                </div>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      );      
    } else {
      return null;
    }
}

  return doRender();

}
